export const UPDATE_LOCALE = 'locale.UPDATE_LOCALE';